import * as i0 from '@angular/core';
import { Pipe, TemplateRef, Component, ViewEncapsulation, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import { retry, take, catchError, of, lastValueFrom } from 'rxjs';
import * as i1$1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/platform-browser';
function IconComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 2);
    i0.ɵɵpipe(1, "sanitizeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind1(1, 3, ctx_r0.htmlText), i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("aria-hidden", ctx_r0.config.ariaHidden ? true : undefined)("aria-label", ctx_r0.config.ariaLabel ? ctx_r0.config.ariaLabel : undefined);
  }
}
function IconComponent_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function IconComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, IconComponent_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.templateRef);
  }
}
class SanitizeHtmlPipe {
  constructor(sanitizer) {
    this.sanitizer = sanitizer;
  }
  transform(v) {
    return this.sanitizer.bypassSecurityTrustHtml(v);
  }
  static {
    this.ɵfac = function SanitizeHtmlPipe_Factory(t) {
      return new (t || SanitizeHtmlPipe)(i0.ɵɵdirectiveInject(i1.DomSanitizer, 16));
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "sanitizeHtml",
      type: SanitizeHtmlPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SanitizeHtmlPipe, [{
    type: Pipe,
    args: [{
      name: 'sanitizeHtml'
    }]
  }], () => [{
    type: i1.DomSanitizer
  }], null);
})();
class IconComponent {
  constructor(httpClient, cdr) {
    this.httpClient = httpClient;
    this.cdr = cdr;
    this.htmlText = '';
    this.configProperties = ['icon', 'className', 'fill', 'height', 'width', 'style', 'ariaLabel', 'ariaHidden'];
    this._input_icon = '';
    this._input_className = '';
    this._input_height = '';
    this._input_width = '';
    this._input_fill = '';
    this._input_style = '';
    this._input_ariaLabel = '';
    this._input_ariaHidden = false;
    // NOTES FOR NEW INPUTS:
    // 1. The internal name should be the public name prefixed by '_input_'.
    // 2. The public name should be added to the configProperties array.
    this.predefinedIcons = {};
    this.cachedIcons = {};
    this.config = {
      icon: ''
    };
    // icon names must not have a period (.) or a hash (#)
    this.predefinedIcons = {
      'sol-plus': '<svg viewBox="0 1 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M18 9H11V2H9V9H2V11H9V18H11V11H18V9Z" /></svg>',
      'sol-dropdown-arrow': '<svg viewBox="3 3 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M13.2653 7.30508L10 10.5593L6.73469 7.30508C6.32653 6.89831 5.71429 6.89831 5.30612 7.30508C4.89796 7.71186 4.89796 8.32203 5.30612 8.72881L9.28571 12.6949C9.38775 12.7966 9.4898 12.8983 9.59184 12.8983C9.69388 13 9.89796 13 10 13C10.102 13 10.3061 13 10.4082 12.8983C10.5102 12.7966 10.6122 12.7966 10.7143 12.6949L14.6939 8.72881C15.102 8.32203 15.102 7.71186 14.6939 7.30508C14.2857 6.89831 13.6735 6.89831 13.2653 7.30508Z" /></svg>',
      'sol-dots-vertical': '<svg viewBox="3 2 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 5C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5C14 6.10457 13.1046 7 12 7C10.8954 7 10 6.10457 10 5ZM10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12ZM10 19C10 17.8954 10.8954 17 12 17C13.1046 17 14 17.8954 14 19C14 20.1046 13.1046 21 12 21C10.8954 21 10 20.1046 10 19Z" /></svg>'
    };
  }
  async ngOnChanges() {
    if (!this._input_icon) {
      return;
    }
    this.prepareConfig();
    let doDetectChanges = false;
    // STRINGS
    // -------
    // Name: icon-plus
    // SVG: ./path/single.svg
    // SVG Sprite: ./path/sprite.svg#my-icon
    // SVG Sprite Symbol: #my-icon
    if (typeof this.config.icon === 'string') {
      const hashCount = (this.config.icon.match(/\#/g) || []).length;
      const dotSvgCount = (this.config.icon.match(/\.svg/g) || []).length;
      let tempString = '';
      // PREDEFINED ICON
      if (this.predefinedIcons[this.config.icon]) {
        tempString = this.predefinedIcons[this.config.icon];
        // SVG SPRITE
      } else if (hashCount === 1) {
        const iconSpriteAndName = this.config.icon.split('#');
        const spritePath = iconSpriteAndName[0];
        const iconName = iconSpriteAndName[1];
        const el = document.querySelector(`symbol#${iconName}`);
        tempString = `<svg><use href="${!el ? spritePath : ''}#${iconName}" ></use></svg>`;
        // SINGLE SVG
      } else if (dotSvgCount === 1) {
        // Get the SVG from the cache, if available
        if (this.cachedIcons[this.config.icon]) {
          tempString = this.cachedIcons[this.config.icon];
        } else {
          await this.fetchSingleSVG(this.config.icon).then(svgText => {
            tempString = svgText;
            doDetectChanges = true;
          });
        }
      }
      // ADD CLASS ATTRIBUTE
      if (this.config.className) {
        tempString = tempString.replace('<svg', `<svg class="${this.config.className}"`);
        tempString = tempString.replace('<img', `<img class="${this.config.className}"`);
      }
      // ADD ALL STYLE-RELATED ATTRIBUTES
      if (this.config.style || this.config.height || this.config.width || this.config.fill) {
        // add a style tag if any style-related attributes are present
        tempString = tempString.replace('<svg', '<svg style=""');
        tempString = tempString.replace('<img', '<img style=""');
        if (this.config.style) {
          this.config.style = this.config.style.replace(/;$/, '') + ';'; // add a semi-colon, if one is not present
          tempString = tempString.replace('style=""', `style="${this.config.style}"`);
        }
        if (this.config.height) {
          tempString = tempString.replace('style="', `style="height:${this.config.height};`);
        }
        if (this.config.width) {
          tempString = tempString.replace('style="', `style="width:${this.config.width};`);
        }
        if (this.config.fill) {
          tempString = tempString.replace('style="', `style="fill:${this.config.fill};`);
        }
      }
      // ADD ARIA LABEL AS ALT ATTRIBUTE IN IMG TAGS
      if (this.config.ariaLabel) {
        tempString = tempString.replace('<img', `<img alt="${this.config.ariaLabel}"`);
      }
      this.templateRef = undefined;
      this.htmlText = tempString;
    }
    // TEMPLATEREF
    if (this.config.icon instanceof TemplateRef) {
      this.htmlText = '';
      this.templateRef = this.config.icon;
    }
    if (doDetectChanges) {
      this.cdr.detectChanges();
    }
  }
  // The icon input can be a single string or TemplateRef, or it can be a configuration object containing
  // all of the inputs. It can also be a combination of both. (Note: The configuration object will take
  // precedence with the following exceptions: the `className` and `style` properties will be combined.)
  // Here we map the inputs to this.config to handle these two different options.
  prepareConfig() {
    let inputsDirect = [];
    let inputsIconConfig = [];
    /* *** START WITH PROPERTIES FROM INPUTS *** */
    // Object.entries creates an array of arrays. For each element in the main array,
    // item[0] is the name of the property and item[1] is the value of that property
    inputsDirect = Object.entries(this).filter(item => item[0].includes('_input_')).map(item => [item[0].replace('_input_', ''), item[1]]);
    inputsDirect.forEach(item => {
      if (this.configProperties.includes(item[0])) {
        this.config[item[0]] = item[1];
      }
    });
    /* *** THEN USE PROPERTIES FROM ICON CONFIGURATION OBJECT INSTEAD OR IN COMBINATION *** */
    if (this._input_icon && this._input_icon.hasOwnProperty('icon')) {
      // Object.entries creates an array of arrays. For each element in the main array,
      // item[0] is the name of the property and item[1] is the value of that property
      inputsIconConfig = Object.entries(this._input_icon);
      inputsIconConfig.forEach(item => {
        if (this.configProperties.includes(item[0])) {
          if (['className', 'style'].includes(item[0])) {
            let separator = ' ';
            if (item[0] === 'style' && this.config.style) separator = ';';
            // combine className and style from direct inputs and the icon config object
            this.config[item[0]] = (this.config[item[0]] + separator + item[1]).trim();
          } else {
            // for all other properties, use the icon config instead of the direct inputs
            this.config[item[0]] = item[1];
          }
        }
      });
    }
  }
  async fetchSingleSVG(url) {
    // Make the HTTP call to fetch the SVG
    const request$ = this.httpClient.get(url, {
      responseType: 'text'
    }).pipe(retry(1), take(1), catchError((error, caught) => {
      // if the SVG cannot be retrieved with get(), then load it through <img>
      return of(`<img src="${url}">`);
    }));
    const svgText = await lastValueFrom(request$);
    this.cachedIcons[url] = svgText;
    return svgText;
  }
  static {
    this.ɵfac = function IconComponent_Factory(t) {
      return new (t || IconComponent)(i0.ɵɵdirectiveInject(i1$1.HttpClient), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IconComponent,
      selectors: [["sol-icon"]],
      inputs: {
        _input_icon: [i0.ɵɵInputFlags.None, "icon", "_input_icon"],
        _input_className: [i0.ɵɵInputFlags.None, "className", "_input_className"],
        _input_height: [i0.ɵɵInputFlags.None, "height", "_input_height"],
        _input_width: [i0.ɵɵInputFlags.None, "width", "_input_width"],
        _input_fill: [i0.ɵɵInputFlags.None, "fill", "_input_fill"],
        _input_style: [i0.ɵɵInputFlags.None, "style", "_input_style"],
        _input_ariaLabel: [i0.ɵɵInputFlags.None, "ariaLabel", "_input_ariaLabel"],
        _input_ariaHidden: [i0.ɵɵInputFlags.None, "ariaHidden", "_input_ariaHidden"]
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 2,
      vars: 2,
      consts: [["class", "sol-icon", "role", "img", 3, "innerHtml", 4, "ngIf"], [4, "ngIf"], ["role", "img", 1, "sol-icon", 3, "innerHtml"], [4, "ngTemplateOutlet"]],
      template: function IconComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, IconComponent_div_0_Template, 2, 5, "div", 0)(1, IconComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.htmlText);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.templateRef);
        }
      },
      dependencies: [i2.NgIf, i2.NgTemplateOutlet, SanitizeHtmlPipe],
      styles: ["sol-icon{display:inline-flex;align-items:center;vertical-align:middle}sol-icon .sol-icon{display:inline-flex;align-items:center}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IconComponent, [{
    type: Component,
    args: [{
      selector: 'sol-icon',
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<div\n  *ngIf=\"htmlText\"\n  class=\"sol-icon\"\n  [attr.aria-hidden]=\"config.ariaHidden ? true : undefined\"\n  [attr.aria-label]=\"config.ariaLabel ? config.ariaLabel : undefined\"\n  role=\"img\"\n  [innerHtml]=\"htmlText | sanitizeHtml\"\n></div>\n<ng-container *ngIf=\"templateRef\">\n  <ng-container *ngTemplateOutlet=\"templateRef\"></ng-container>\n</ng-container>\n",
      styles: ["sol-icon{display:inline-flex;align-items:center;vertical-align:middle}sol-icon .sol-icon{display:inline-flex;align-items:center}\n"]
    }]
  }], () => [{
    type: i1$1.HttpClient
  }, {
    type: i0.ChangeDetectorRef
  }], {
    _input_icon: [{
      type: Input,
      args: ['icon']
    }],
    _input_className: [{
      type: Input,
      args: ['className']
    }],
    _input_height: [{
      type: Input,
      args: ['height']
    }],
    _input_width: [{
      type: Input,
      args: ['width']
    }],
    _input_fill: [{
      type: Input,
      args: ['fill']
    }],
    _input_style: [{
      type: Input,
      args: ['style']
    }],
    _input_ariaLabel: [{
      type: Input,
      args: ['ariaLabel']
    }],
    _input_ariaHidden: [{
      type: Input,
      args: ['ariaHidden']
    }]
  });
})();
class IconModule {
  static {
    this.ɵfac = function IconModule_Factory(t) {
      return new (t || IconModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: IconModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, HttpClientModule, HttpClientModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IconModule, [{
    type: NgModule,
    args: [{
      declarations: [IconComponent, SanitizeHtmlPipe],
      imports: [CommonModule, HttpClientModule],
      exports: [IconComponent, HttpClientModule]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { IconComponent, IconModule, SanitizeHtmlPipe };
